import React, { useState } from 'react'
import "./addpartlist.scss";
import { TreeviewDropdown } from '../../CommonComponent';
import { Iprops } from './addpartlistinterface';
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import { useSelector } from "react-redux";
import { selectors as globalDataSelector } from "../../../state/features/common/globaldata";
import { selectors as headerSelector } from "../../../state/features/header";
import partsService from "../../../services/partsservice";
import helperfunctions from '../../../utils/helperfunctions';
import Alerts from '../../Alerts';
const Addpartlist = (props:Iprops) => {

  const { t } = useTranslation();
  const { headercurrentuser: { azureADId } }: any = useSelector((state) => ({
      headercurrentuser: headerSelector.currentuser(state),
  }));

  const { globalData }: any = useSelector((state) => ({
      globalData: globalDataSelector.globaldata(state),
  }));

  let clonePartListItem = JSON.parse(JSON.stringify(props?.partsListItems??[]));
  const recentItems = props?.partsListItems?.slice(0, 3) ?? [];
  const sortedPartList = clonePartListItem?.sort((a: any, b: any) => a?.partsListName.localeCompare(b?.partsListName))??[];
  const partListOptions = sortedPartList?.map((t: any) => ({ title: t.partsListName, value: t.partsListID })) ?? [];
  const [selectedItems, setSelectedItem] = useState<any>([]);

    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [errorSuccessMessage, setErrorSuccessMessage] = useState<string>("");
    const showErrorMessage = (message: any) => {
        setErrorSuccessMessage(message);
        setShowAlert(true);
    }

    const handleErrorClose = () => {
        setErrorSuccessMessage('');
        setShowAlert(false);
    };

    const savePartList = () => {
        if (selectedItems?.length > 0) {
          const model = {
              customerId: globalData?.CustomerId,
              ListIds: selectedItems?.join(","),
              userAadId: azureADId,
              branchCode: globalData?.BranchCode,
              distributorCode: globalData?.DistributorCode,
              recommendedPartsAddToList: props?.selectedBookmarkItem?.map((t: any) => ({
                      description: t.partDescription,
                      manufacturerCode : t.manufacturerCode,
                      partNo: t.partNumber,
                      quantity: t.quantity,
                      manufacturerName : t.manufacturerName,
                      model: t.machine,
                      serialNumber: t.serialNumber ?? ""
              }))
          }

          partsService.savePartListDataWithBookmarkItem(model)
              .then((response: any) => {
                  if (response.isSuccessful) {
                      helperfunctions.showSuccessMessage(response?.message ?? t(RESOURCE.MyK_Label_SC_Partlist_Save_Success));
                      props.getPartsListItemsForGrid();
                      props.getBookmarkItems();
                      onCancel();
                  }
                  else
                      helperfunctions.showErrorMessage(response?.message ?? t(RESOURCE.MyK_Label_SC_Partlist_Save_Error));
              })
              .catch((e: any) => {
                  helperfunctions.showErrorMessage(e);
              });
      }
      else {
          showErrorMessage(t(RESOURCE.MyK_Label_SC_Add_PartList_Validation_OnePartList));
      }
  }

  const handleOnChange = (value: any) => {
      setSelectedItem(value);
  }

  const onSelectionChange = (e: any, value: any) => {
      if (e.target.checked) {
          setSelectedItem((previousState : any) => ([...previousState, value]));
      }
      else {
         const updatedItems = selectedItems?.filter((t: any) => t != value) ?? [];
         setSelectedItem(updatedItems);
      }
    }

    const onCancel = () => {
        setSelectedItem([]);
        props.addtoListOnClick();
    }

    return (
        <div className='addpartlist_wrapper'>
            <div className='recentpartslist'>
                {showAlert && (
                    <Alerts
                        messageAlert={errorSuccessMessage}
                        alertType={'error'}
                        time={3000} onClose={() => handleErrorClose()}
                    />
                )}
                <div className='recentpastlist mb-3'>{t(RESOURCE.MyK_Label_ShoppingCart_Recent_PartList)}</div>
                <div className='recentpartlistcheckboxs pl-4'>
                    {recentItems?.map((t: any) => 
                        <div className='mb-2' key={t.partsListID}>
                            <span className='mr-2' key={"innerdiv" + t.partsListID}>
                                <input key={"input" + t.partsListID} onChange={(e: any) => onSelectionChange(e, t.partsListID)} checked={selectedItems?.filter((s: any) => s == t.partsListID)?.length > 0} type='checkbox' className='recentpartcheck'></input></span>
                            <span key={"span" + t.partsListID}>{t.partsListName}</span>
                        </div> 
                    )}
                   
                </div>
                <div className='addpartslist mt-4 mb-3'>
                    <span className='mr-2 addpartslist_heading'>{t(RESOURCE.MyK_Label_ShoppingCart_Add_PartList)}</span><span>
                        <TreeviewDropdown
                            treeData={partListOptions}
                            multiple={true}
                            showSearch={true}
                            treeNodeFilterProp={"title"}
                            className={'multislectDropdown partlist-ddl'}
                            dropdownClassName={'dropdownListContainer noNested'}
                            placeholder={t(RESOURCE.MyK_Label_SelectOption)}
                            value={selectedItems}
                            onChange={handleOnChange}
                        />
                     </span> 
                </div>
                <div className="partlist_footer partlist-button">
                    <button className="savebtn mr-2" onClick={savePartList} title={t(RESOURCE.MyK_Label_Save)}><span className="fa fa-floppy-o mr-1"></span>{t(RESOURCE.MyK_Label_Save)}</button>
                    <button className="cancelbtn" onClick={onCancel} title={t(RESOURCE.MyK_Label_Cancel)}><span className="fa fa-times mr-1"></span>{t(RESOURCE.MyK_Label_Cancel)}</button>
                </div>
               
            </div>
        </div>
    )
}

export default Addpartlist